<template>
    <v-form lazy-validation ref="form" @submit.prevent="validate">
        <div class="md-layout">
            <div class="md-layout-item md-size-100">
            
                <v-text-field v-model="user.name" label="姓名 *" hint="请输入您的真实姓名" :rules="[v => !!v || '姓名不能为空']"></v-text-field>
                <v-select v-model="user.sex" :items="sexItems" item-text="name" item-value="value" label="性别"></v-select>
                <v-text-field v-model="user.job_title" label="职称" hint="请输入您的职称"></v-text-field>
                <v-row align="center">
                    <v-col class="d-flex" cols="12" sm="4">
                        <v-select v-model="user.province" :items="provinceList" item-text="name" item-value="code" label="地址：省" v-on:change="change('province', 1)"></v-select>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4">
                        <v-select v-model="user.city" :items="cityList" item-text="name" item-value="code" label="市" v-on:change="change('city', 1)"></v-select>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4">
                        <v-select v-model="user.region" :items="regionList" item-text="name" item-value="code" label="区/县" v-on:change="change('region', 1)"></v-select>
                    </v-col>
                </v-row>
                <v-text-field v-model="user.detail_address" name="detail_address" label="详细地址" hint="请输入您的详细地址"></v-text-field> 
                <!-- <v-text-field v-model="user.unit" label="单位" hint="请输入您的单位称"></v-text-field>
                <v-text-field v-model="user.secondary_unit" label="二级单位" hint="请输入您的单位称"></v-text-field> -->
  

            </div>
        </div>
    </v-form>
</template>
<script>
import { professionList, areaList } from '@/api/user';

export default {
    props: {
        // avatar: {
        //     type: String,
        //     default: "./img/default-avatar.png",
        // },
        user: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            areaListData: [],
            professionListData: [],
            provinceList: [],
            cityList: [],
            regionList: [],
            sexItems: [
                { value: '0', name: '男' },
                { value: '1', name: '女' }
            ],
        };
    },
    watch: {
        ['user.address']() {
            this.setAddress();
        }
    },
    created() {
      console.log(this.user)
        this.professionList();
        this.areaList();
        this.renderPage()

    
    },
    methods: {
      renderPage(){
        let  {nickName,sex,academicTitle,addressList,addressDetail} = this.user.user
            this.user.name = nickName     //姓名
            this.user.sex = sex          //性别
            this.user.job_title = academicTitle   //职称
            this.user.province =  addressList[0]     //province  
            this.user.city = addressList[1]     //     city  region
            this.user.region = addressList[2]     // region
            this.user.detail_address  = addressDetail //详细地址
             areaList().then((res) => {
                if (res.code === '200') {
                 let provinceData =  res.data.filter(item=>item.code==addressList[0])
                   if(provinceData.length<=0) return 
                     this.cityList = provinceData[0].children;
                     let cityData =   provinceData[0].children.filter(item=>item.code==addressList[1]);
                     if(cityData.length<=0) return 
                     this.regionList =   cityData[0].children
                }
            })
        
            // this.user.user.professionId = validated.userData.professionId   //职业
            // this.user.user.nickName = validated.userData.unit      //单位
            // this.user.user.nickName = validated.userData.secondary_unit      //二级单位

      },
        change(type, reset) {
            if (type === 'province') {
                this.cityList = [];
                this.regionList = [];
                if (reset) {
                    this.user.city = '';
                    this.user.region = '';
                };
                this.setCityList();
            }
            if (type === 'city') {
                this.regionList = [];
                this.setRegionList();
                if (reset) {
                    this.user.region = '';
                };
            }
        },
        setCityList() {
            this.provinceList.forEach(v => {
                if (this.user.province === v.code) {
                    this.cityList = v.children;
                }
            });
        },
        setRegionList() {
            this.cityList.forEach(v => {
                if (this.user.city === v.code) {
                    this.regionList = v.children;
                }
            });
        },
        professionList(params) {
            professionList().then((res) => {
                if (res.code === '200') {
                    this.professionListData = res.data;
                }
            })
        },
        setAddress() {
            this.user.province = this.user.address[0] || this.user.province || '';
            this.change('province');
            this.user.city = this.user.address[1] || this.user.city || '';
            this.change('city');
            this.user.region = this.user.address[2] || this.user.region || '';
        },
        async areaList(params) {
            await areaList().then((res) => {
                if (res.code === '200') {
                    this.provinceList = res.data;
                    if (this.user.address) {
                        this.setAddress();
                    }
                }
            })
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("on-validated", {
                    step:'step2',
                    userData:this.user,
                });
                return true;
            }
        },
        getUser() {
            return this.user;
        }
    },
};
</script>